import { Button, ColorPicker, Form, Input, message, Space } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { serverFetch } from "../../../server";
import { tagObjectVidLabels } from "./tags-const";

const defaultItem = (companyId, objectVid) => ({
  companyId,
  objectVid,
  value: "",
  color: "#1677ff",
});

const TagModal = ({ id, objectVid, companyId, onClose }) => {
  const [item, setItem] = useState(() => defaultItem(companyId, objectVid));
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const getData = () => {
    if (id) {
      setLoading(true);
      serverFetch("Tag/id", { queryParams: { id } })
        .then((data) => {
          setLoading(false);
          setItem(data);
          form.setFieldsValue({
            value: data.value,
            color: normalizeColorHex(data.color),
          });
        })
        .catch((e) => {
          setLoading(false);
          message.error(e.userMessage);
        });
    } else {
      const initial = defaultItem(companyId, objectVid);
      setItem(initial);
      form.setFieldsValue({
        value: "",
        color: initial.color,
      });
    }
  };

  useEffect(getData, [id, companyId, objectVid, form]);

  const onValuesChange = (changed) => {
    setItem((prev) => ({ ...prev, ...changed }));
  };

  const onSave = () => {
    form.validateFields().then(() => {
      const value = form.getFieldValue("value")?.trim() ?? "";
      const colorRaw = form.getFieldValue("color");
      const color = typeof colorRaw === "string" ? normalizeColorHex(colorRaw) : colorRaw?.toHexString?.() ?? "";

      setLoading(true);
      if (id) {
        const payload = {
          id,
          companyId: item.companyId,
          objectVid: item.objectVid,
          value,
          color,
        };
        serverFetch("Tag", { method: "PUT", bodyData: payload })
          .then(() => onClose(true))
          .catch((e) => {
            setLoading(false);
            message.error(e.userMessage);
          });
      } else {
        const payload = {
          companyId,
          objectVid,
          value,
          color,
        };
        serverFetch("Tag", { method: "POST", bodyData: payload })
          .then(() => onClose(true))
          .catch((e) => {
            setLoading(false);
            message.error(e.userMessage);
          });
      }
    });
  };

  return (
    <div className="sport-modal">
      <div className="sport-modal-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose(false)}>
        <div className="sport-modal-content" style={{ width: 480 }} onMouseDown={(e) => e.stopPropagation()}>
          <div className="sport-modal-title">
            <span>{id ? "Тег" : "Новый тег"}</span>
            <CloseOutlined className="sport-section-title-close" onClick={() => onClose(false)} />
          </div>
          <Form
            form={form}
            onValuesChange={onValuesChange}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 24 }}
            colon={false}
            disabled={loading}
          >
            <Form.Item label="Тип">
              <Input value={tagObjectVidLabels[item.objectVid ?? objectVid] ?? ""} disabled />
            </Form.Item>
            <Form.Item name="value" label="Название" rules={[{ required: true, message: "Введите название" }]}>
              <Input placeholder="Название тега" maxLength={120} />
            </Form.Item>
            <Form.Item
              name="color"
              label="Цвет"
              rules={[
                { required: true, message: "Укажите цвет" },
                { pattern: /^#([0-9a-fA-F]{6})$/, message: "Формат #RRGGBB" },
              ]}
              getValueFromEvent={(c) => (typeof c === "string" ? c : c?.toHexString?.())}
              getValueProps={(v) => ({ value: v ? normalizeColorHex(v) : "#1677ff" })}
            >
              <ColorPicker format="hex" showText={(c) => (typeof c === "string" ? c : c?.toHexString?.())} style={{ width: "100%" }} />
            </Form.Item>
            <Form.Item label=" ">
              <Space>
                <Button type="primary" onClick={onSave} loading={loading}>
                  Сохранить
                </Button>
                <Button onClick={() => onClose(false)}>Закрыть</Button>
              </Space>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default TagModal;

function normalizeColorHex(s) {
  if (s == null || s === "") return "#1677ff";
  const t = String(s).trim();
  return t.startsWith("#") ? t : `#${t}`;
}
